import { TypedUseSelectorHook, useSelector as useUntypedSelector } from 'react-redux'
import { RootState } from '../reducers/root'

export const useSelector: TypedUseSelectorHook<RootState> = useUntypedSelector
